<template>

    <div class="row">
        <div class="col-4 mb-4 mb-lg-0">
            <h4 class="first mb-lg-5  mb-2 "> aktualności</h4>
        </div>
        <div class="col-12 col-lg-3 offset-lg-2 order-2 order-lg-0  mb-3"><!--select1-->
            <div class="input-group -select">
                <treeselect class="treeselect-wrap "
                            name="selectedPriorities"
                            placeholder="pokaż:  wszystkie aktualności"
                            :multiple="false"
                            :clearable="true"
                            :searchable="true"
                            :open-on-click="true"
                            :open-on-focus="false"
                            :clear-on-select="true"
                            :close-on-select="true"
                            :always-open="false"
                            :append-to-body="false"
                            :options="options"
                            v-model="selectedOption">

                    <label slot="option-label" slot-scope="{ node }">
                        {{ node.raw.val}}
                    </label>

                    <label slot="value-label"
                           slot-scope="{ node }">
                        {{ node.raw.val}}
                    </label>
                </treeselect>

            </div>
        </div>
        <div class="col-12 col-lg-3  order-1  mb-3 ">
            <div class="input-group custom ">
                <input type="text" class="" placeholder="szukaj sklepu" >
                <span class="input-icon -search" ></span>
            </div>

        </div>

    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect'

    export default {
        name: "Header",
        components: {
            Treeselect
        },
        data() {
            return {
                options: [
                    {
                        id: 1,
                        val: 'some val 1'
                    },
                    {
                        id: 2,
                        val: 'some val 2'
                    },
                    {
                        id: 3,
                        val: 'some val 3'
                    },
                ],
                selectedOption: null
            }
        }
    }
</script>

<style>


</style>


// WEBPACK FOOTER //
// src/components/Header.vue